import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const OCCUPATION_CREATE_RESOURCE = "occupation" as const;
export const OCCUPATION_CREATE_API_PATH = `/v1/${OCCUPATION_CREATE_RESOURCE}` as const;

export type OccupationCreateBody =
  paths[typeof OCCUPATION_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type OccupationCreateResponse =
  paths[typeof OCCUPATION_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useOccupationCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<OccupationCreateResponse, Error, OccupationCreateBody>({
    mutationFn: async (occupation: OccupationCreateBody) => {
      const response = await alphartisApiAxios.post<OccupationCreateResponse>(OCCUPATION_CREATE_API_PATH, occupation);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [OCCUPATION_CREATE_RESOURCE],
      });
    },
  });
};
